import { render, staticRenderFns } from "./TotalCostsTable.vue?vue&type=template&id=cca2e400&scoped=true"
import script from "./TotalCostsTable.vue?vue&type=script&lang=js"
export * from "./TotalCostsTable.vue?vue&type=script&lang=js"
import style0 from "./TotalCostsTable.vue?vue&type=style&index=0&id=cca2e400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca2e400",
  null
  
)

export default component.exports